import { render } from "./TicketsView.vue?vue&type=template&id=2789d210&scoped=true"
import script from "./TicketsView.vue?vue&type=script&lang=js"
export * from "./TicketsView.vue?vue&type=script&lang=js"

import "./TicketsView.vue?vue&type=style&index=0&id=2789d210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2789d210"]])

export default __exports__